import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {UntypedFormGroup} from '@angular/forms';
import {DatePipe} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private router: Router,
              private datePipe: DatePipe) {
  }

  /** Redirect to a url */
  public GoTo(url: string): void {
    this.router.navigate([url]);
  }

  /** Return True if a form's control is invalid */
  public ctlInvalid(frm: UntypedFormGroup, ctlName: string): boolean {
    return frm.controls[ctlName].invalid && (frm.controls[ctlName].dirty || frm.controls[ctlName].touched);
  }

  /**
   * Compares two Date objects and returns e number value that represents
   * the result:
   * 0 if the two dates are equal.
   * 1 if the first date is greater than second.
   * -1 if the first date is less than second.
   * @param date1 First date object to compare.
   * @param date2 Second date object to compare.
   */
  public compareDate(date1: Date, date2: Date): number {
    // With Date object we can compare dates them using the >, <, <= or >=.
    // The ==, !=, ===, and !== operators require to use date.getTime(),
    // so we need to create a new instance of Date with 'new Date()'
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    // Check if the dates are equal
    const same = d1.getTime() === d2.getTime();
    if (same) {
      return 0;
    }
    // Check if the first is greater than second
    if (d1 > d2) {
      return 1;
    }
    // Check if the first is less than second
    if (d1 < d2) {
      return -1;
    }
  }

  convertDateAsString(date: Date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd\'T\'HH:mm:ss\'Z\'');
  }

  buildObjectValid(object: any) {
    for (const property in object) {
      if (object[property] === null || object[property] === undefined) {
        delete object[property];
      }
    }
  }

  sleep(milliseconds: number) {
    return new Promise(
      resolve => setTimeout(resolve, milliseconds)
    );
  }

  roundTo(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  };

}
